<template>
  <h4 class="in-page-title" :style="inPagetitleStyles">
    <slot />
  </h4>
</template>

<script>
export default {
  name: 'InPageTitle',
  props: {
    color: {
      type: String,
      default: '#FF6841'
    }
  },
  computed: {
    inPagetitleStyles () {
      return {
        color: this.color
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.in-page-title {
  font-size: 14px;
  letter-spacing: -0.55px;

  @media (min-width: $screen-md) {
    letter-spacing: -0.79px;
    font-size: 20px;
  }
}
</style>
